export const TABS = {
  ICON: 'icon',
  TEXT: 'text',
  LINK: 'link',
};
